import React from 'react';
import { getBrandPresenceSubTabClassName } from './BrandPresenceTabStyles';

export type GovernanceJobsViewMode = 'task-group' | 'task';

export function GovernanceJobsViewSwitch({
  mode,
  onChange,
}: {
  mode: GovernanceJobsViewMode;
  onChange: (mode: GovernanceJobsViewMode) => void;
}) {
  return (
    <div className="inline-flex items-center gap-0.5 rounded-xl bg-slate-100/90 p-1" role="group" aria-label="Show jobs as">
      <button
        className={getBrandPresenceSubTabClassName(mode === 'task-group')}
        onClick={() => onChange('task-group')}
        type="button"
        aria-pressed={mode === 'task-group'}
      >
        Task Group
      </button>
      <button
        className={getBrandPresenceSubTabClassName(mode === 'task')}
        onClick={() => onChange('task')}
        type="button"
        aria-pressed={mode === 'task'}
      >
        Task
      </button>
    </div>
  );
}
